var netalicoSearch = {
    options: {
        formSelector: '#search_mini_form',
        destinationSelector: '#search_autocomplete',
        autocomplete: 'off',
        minSearchLength: 2,
        responseFieldElements: 'ul li',
        selectClass: 'selected',
        template: '',
        submitBtn: 'button[type="submit"]',
        searchType: 'select[name="search-type"]'
    },
    responseList: {
        indexList: null,
        selected: null
    },
    element: null,
    KeyCodes: {
        HOME: 36,
        END: 35,
        ESCAPE: 27,
        ENTER: 13,
        DOWN: 40,
        UP: 38
    },

    init: function () {
        this.element = jQuery('#Search-In-Modal');
        this.autoComplete = jQuery(this.options.destinationSelector);
        this.searchForm = jQuery(this.options.formSelector);
        this.searchType = jQuery(this.options.searchType);
        this.submitBtn = this.searchForm.find(this.options.submitBtn)[0];
        _.bindAll(this, '_onKeyDown', '_onPropertyChange', '_onSubmit');

        this.submitBtn.disabled = true;

        this.element.attr('autocomplete', this.options.autocomplete);

        this.element.on('blur', jQuery.proxy(function () {
            setTimeout(jQuery.proxy(function () {
                this.autoComplete.hide();
                this._updateAriaHasPopup(false);
            }, this), 250);
        }, this));

        this.element.trigger('blur');

        this.element.on('keydown', this._onKeyDown);
        this.element.on('input propertychange', this._onPropertyChange);

        this.searchForm.on('submit', jQuery.proxy(function(e) {
            e.preventDefault();
            this._onSubmit();
            this._updateAriaHasPopup(false);
        }, this));
    },

    /**
     * @private
     * @return {Element} The first element in the suggestion list.
     */
    _getFirstVisibleElement: function () {
        return this.responseList.indexList ? this.responseList.indexList.first() : false;
    },

    /**
     * @private
     * @return {Element} The last element in the suggestion list.
     */
    _getLastElement: function () {
        return this.responseList.indexList ? this.responseList.indexList.last() : false;
    },

    /**
     * @private
     * @param {Boolean} show Set attribute aria-haspopup to "true/false" for element.
     */
    _updateAriaHasPopup: function(show) {
        if (show) {
            this.element.attr('aria-haspopup', 'true');
        } else {
            this.element.attr('aria-haspopup', 'false');
        }
    },

    /**
     * Clears the item selected from the suggestion list and resets the suggestion list.
     * @private
     * @param {Boolean} all - Controls whether to clear the suggestion list.
     */
    _resetResponseList: function (all) {
        this.responseList.selected = null;

        if (all === true) {
            this.responseList.indexList = null;
        }
    },

    /**
     * Executes when the search box is submitted. Sets the search input field to the
     * value of the selected item. Default-prevention is handled by the wired
     * submit handler, which calls this with no event argument.
     * @private
     */
    _onSubmit: async function () {
        var value = this.element.val();
        if (this.isEmpty(value)) {
            return false;
        }
        value = value.trim();
        if (this.responseList.selected) {
            value = this.responseList.selected.text();
            this.element.val(value);
        }

        if (window.SHOPIFY_STOREFRONT_TOKEN) {
            const type = this.searchType.val();
            const handle = this._handleize(value);
            try {
                // 1. Exact match: the whole search phrase matches a Search Redirect entry.
                let url = this._redirectUrl(await this._fetchRedirectEntry('search_redirect', handle), type);

                // 2. Keyword match: if there is no exact match, redirect when any word in
                //    the query matches a Search Keyword Redirect entry (e.g. "brick").
                //    The longest word is tried first so the most specific keyword wins.
                if (!url) {
                    const words = Array.from(new Set(handle.split('-')))
                        .filter((w) => w.length > 2)
                        .sort((a, b) => b.length - a.length)
                        .slice(0, 6);
                    if (words.length) {
                        const entries = await Promise.all(
                            words.map((w) => this._fetchRedirectEntry('search_keyword_redirect', w))
                        );
                        for (let i = 0; i < entries.length && !url; i++) {
                            url = this._redirectUrl(entries[i], type);
                        }
                    }
                }

                if (url) {
                    window.location.href = url;
                    return false;
                }
            } catch (err) {
                console.error('Search redirect lookup failed:', err);
            }
        }

        // Remove any inputs left by a prior submit so a rapid double-submit
        // cannot stack duplicate/conflicting product_type filters.
        this.searchForm.find('input[name="filter.p.product_type"], input[name="sort_by"]').remove();
        if(this.searchType.val() === 'wallpaper') {
            // add hidden input to form
            this.searchForm.append('<input type="hidden" name="filter.p.product_type" value="ShopifyWallpaper">');
        } else if(this.searchType.val() === 'canvas') {
            this.searchForm.append('<input type="hidden" name="filter.p.product_type" value="ShopifyCanvas">');
        } else {
            this.searchForm.append('<input type="hidden" name="filter.p.product_type" value="ShopifyMural">');
        }
        this.searchForm.append('<input type="hidden" name="sort_by" value="relevance">');

        this.searchForm[0].submit();
    },

    _handleize: function (value) {
        return value.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    },

    /**
     * Picks the redirect URL for the active search type from a metaobject entry.
     * The type-specific URL wins; otherwise it falls back to other_redirect.
     * @private
     */
    _redirectUrl: function (entry, type) {
        if (!entry) return null;
        if (entry[type]) return entry[type];
        if (entry.other && !entry.mural && !entry.canvas && !entry.wallpaper) return entry.other;
        return null;
    },

    /**
     * Fetches a redirect metaobject by type + handle and maps its fields to
     * { mural, canvas, wallpaper, other }. Returns null when nothing matches.
     * Used for both 'search_redirect' (exact phrase) and 'search_keyword_redirect'
     * (per-word keyword) lookups, which share the same field keys.
     * @private
     */
    _fetchRedirectEntry: async function (type, handle) {
        if (!handle) return null;
        // Cache-bust: Shopify's edge can briefly cache a "not found" for a
        // freshly-created metaobject handle. The unique ?_= param varies the
        // edge cache key so a new handle resolves without waiting for the cache
        // to expire. NOTE: documented multi-hour regional metaobject staleness
        // is server-side and is NOT cleared by this.
        // API version must be rotated within Shopify's ~12-month support window;
        // keep in sync with theme.liquid (currently 2025-04).
        const response = await fetch('/api/2025-04/graphql.json?_=' + Date.now(), {
            method: 'POST',
            cache: 'no-store',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': window.SHOPIFY_STOREFRONT_TOKEN
            },
            body: JSON.stringify({
                query: 'query GetRedirect($handle: MetaobjectHandleInput!) { metaobject(handle: $handle) { fields { key value } } }',
                variables: { handle: { type: type, handle: handle } }
            })
        });
        if (!response.ok) console.warn('Search redirect HTTP', response.status);
        const json = await response.json();
        if (json && json.errors) console.warn('Search redirect GraphQL errors:', json.errors);
        const fields = json && json.data && json.data.metaobject && json.data.metaobject.fields;
        if (!fields) return null;
        const entry = {};
        fields.forEach(function (f) {
            var value = (f.value || '').trim();
            if (f.key === 'mural_redirect') entry.mural = value;
            else if (f.key === 'canvas_redirect') entry.canvas = value;
            else if (f.key === 'wallpaper_redirect') entry.wallpaper = value;
            else if (f.key === 'other_redirect') entry.other = value;
        });
        return entry;
    },

    /**
     * Executes when keys are pressed in the search input field. Performs specific actions
     * depending on which keys are pressed.
     * @private
     * @param {Event} e - The key down event
     * @return {Boolean} Default return type for any unhandled keys
     */
    _onKeyDown: function (e) {
        var keyCode = e.keyCode || e.which;
        switch (keyCode) {
            case this.KeyCodes.HOME:
                this._getFirstVisibleElement().addClass(this.options.selectClass);
                this.responseList.selected = this._getFirstVisibleElement();
                break;
            case this.KeyCodes.END:
                this._getLastElement().addClass(this.options.selectClass);
                this.responseList.selected = this._getLastElement();
                break;
            case this.KeyCodes.ESCAPE:
                this._resetResponseList(true);
                this.autoComplete.hide();
                break;
            case this.KeyCodes.ENTER:
                // Enter is intentionally left to native form submission
                // (handled by the form's submit listener).
                break;
            case this.KeyCodes.DOWN:
                if (this.responseList.indexList) {
                    if (!this.responseList.selected) {
                        this._getFirstVisibleElement().addClass(this.options.selectClass);
                        this.responseList.selected = this._getFirstVisibleElement();
                    }
                    else if (!this._getLastElement().hasClass(this.options.selectClass)) {
                        this.responseList.selected = this.responseList.selected.removeClass(this.options.selectClass).next().addClass(this.options.selectClass);
                    } else {
                        this.responseList.selected.removeClass(this.options.selectClass);
                        this._getFirstVisibleElement().addClass(this.options.selectClass);
                        this.responseList.selected = this._getFirstVisibleElement();
                    }
                    this.element.val(this.responseList.selected.text());
                    this.element.attr('aria-activedescendant', this.responseList.selected.attr('id'));
                }
                break;
            case this.KeyCodes.UP:
                if (this.responseList.indexList !== null) {
                    if (!this._getFirstVisibleElement().hasClass(this.options.selectClass)) {
                        this.responseList.selected = this.responseList.selected.removeClass(this.options.selectClass).prev().addClass(this.options.selectClass);

                    } else {
                        this.responseList.selected.removeClass(this.options.selectClass);
                        this._getLastElement().addClass(this.options.selectClass);
                        this.responseList.selected = this._getLastElement();
                    }
                    this.element.val(this.responseList.selected.text());
                    this.element.attr('aria-activedescendant', this.responseList.selected.attr('id'));
                }
                break;
            default:
                return true;
        }
    },

    /**
     * Executes when the value of the search input field changes. Executes a GET request
     * to populate a suggestion list based on entered text. Handles click (select), hover,
     * and mouseout events on the populated suggestion list dropdown.
     * @private
     */
    _onPropertyChange: function () {
        var searchField = this.element,
            clonePosition = {
                position: 'absolute',
                width: searchField.outerWidth()
            },
            dropdown = jQuery('<ul role="listbox"></ul>'),
            value = this.element.val();

        this.submitBtn.disabled = this.isEmpty(value);

        if (value.length >= parseInt(this.options.minSearchLength, 10)) {
            jQuery.getJSON('https://autocomplete.fotolia.com/?language_id=2&query=' + encodeURIComponent(value) + '&callback=?',jQuery.proxy(function (data) {
                if(_.has(data,'hits')) {
                    jQuery.each(data['hits'], function(index, element) {
                        element.index = index;
                        var html = '<li id="qs-option-' + index +'" role="option">' + element.term + '</li>';
                        dropdown.append(html);
                    });
                    this.responseList.indexList = this.autoComplete.html(dropdown)
                        .css(clonePosition)
                        .show()
                        .find(this.options.responseFieldElements + ':visible');

                    this._resetResponseList(false);
                    this.element.removeAttr('aria-activedescendant');

                    if (this.responseList.indexList.length) {
                        this._updateAriaHasPopup(true);
                    } else {
                        this._updateAriaHasPopup(false);
                    }

                    this.responseList.indexList
                        .on('click', function (e) {
                            this.responseList.selected = jQuery(e.target);
                            this.searchForm.trigger('submit');
                        }.bind(this))
                        .on('mouseenter mouseleave', function (e) {
                            this.responseList.indexList.removeClass(this.options.selectClass);
                            jQuery(e.target).addClass(this.options.selectClass);
                            this.responseList.selected = jQuery(e.target);
                            this.element.attr('aria-activedescendant', jQuery(e.target).attr('id'));
                        }.bind(this))
                        .on('mouseout', function (e) {
                            if (!this._getLastElement() && this._getLastElement().hasClass(this.options.selectClass)) {
                                jQuery(e.target).removeClass(this.options.selectClass);
                                this._resetResponseList(false);
                            }
                        }.bind(this));
                }
            }, this));
        } else {
            this._resetResponseList(true);
            this.autoComplete.hide();
            this._updateAriaHasPopup(false);
            this.element.removeAttr('aria-activedescendant');
        }
    },

    isEmpty: function(value) {
        return value == null || value.trim().length === 0;
    },
}
var limitlessSearch = Object.create(netalicoSearch);
jQuery(document).ready(function () {
    limitlessSearch.init();
});
